import { getField, updateField } from 'vuex-map-fields';
import { types } from './mutation-types';

function getDefaultState() {
  return {
    accountNumber: '',
    isVatExceptionChecked: false,
    showVatExceptionCheckbox: false,
  };
}

export const bankNumber = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  actions: {
    handleAccountNumberChange({ commit }, newAccountNumber) {
      commit(types.SET_ACCOUNT_NUMBER, newAccountNumber);
    },
    hydrate({ commit }, state) {
      commit(types.HYDRATE, state);
    },
  },
  mutations: {
    updateField,
    [types.SET_ACCOUNT_NUMBER](state, newAccountNumber) {
      state.accountNumber = newAccountNumber;
    },
    [types.HYDRATE](state, payload = {}) {
      Object.assign(state, getDefaultState(), payload);
    },
  },
};
